export const minSearchTermLength = 2
